// Fingerprints the risk data for the initial-only quote cache (excludes additional-only answers, which
// don't affect the initial rating), so a return to the first display can reload instead of re-rating.

// Element keys that live only in the additional step (schema-derived, so no hand-maintained list to drift);
// a field shared with another step (e.g. RetailAddress) is not additional-only and stays in the fingerprint.
export function additionalOnlyKeys(formSchema: Record<string, any>, additionalStepKey = 'assumptions'): string[] {
    const steps = formSchema ?? {};
    const additional = Object.keys(steps[additionalStepKey] ?? {});
    const elsewhere = new Set<string>();
    for (const [key, step] of Object.entries(steps)) {
        if (key === additionalStepKey) continue;
        for (const el of Object.keys(step ?? {})) elsewhere.add(el);
    }
    return additional.filter((k) => !elsewhere.has(k));
}

function stableStringify(value: any): string {
    if (value === null || typeof value !== 'object') return JSON.stringify(value) ?? 'null';
    if (Array.isArray(value)) return '[' + value.map(stableStringify).join(',') + ']';
    return '{' + Object.keys(value).sort().map((k) => JSON.stringify(k) + ':' + stableStringify(value[k])).join(',') + '}';
}

export function fingerprintRisk(riskData: Record<string, any> | null | undefined, excludeKeys: string[]): string {
    if (!riskData) return '';
    const exclude = new Set(excludeKeys);
    const subset: Record<string, any> = {};
    for (const key of Object.keys(riskData)) {
        if (!exclude.has(key)) subset[key] = riskData[key];
    }
    return stableStringify(subset);
}
